<template>
  <div style="padding-bottom: 64px;">
    <!-- <van-nav-bar
      title="教育经历"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    >
    </van-nav-bar> -->
    <van-form @submit="submit" class="form">
      <van-cell-group class="form-cont">
        <van-field
          input-align="right"
          label="学校名称"
          required
          v-model="detail.schoolName"
          placeholder="请输入有效学校名称"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          readonly
          clickable
          required
          label="学历"
          input-align="right"
          is-link
          :value="detail.edu"
          placeholder="请选择真实学历"
          @click="showSelect('edu')"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-if="detail.edu && isCert.includes(detail.edu)"
          input-align="right"
          readonly
          required
          clickable
          placeholder="请选择真实信息"
          @click="showSelect('certificate')"
          is-link
          :value="detail.certificate"
          label="是否拥有学位"
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>
        <van-field
          v-if="detail.edu && !isMajor.includes(detail.edu)"
          input-align="right"
          label="所学专业"
          required
          v-model="detail.majorName"
          placeholder="请输入有效专业"
          :rules="[{ required: true, message: '' }]"
        />
        <!-- <van-field
          input-align="right"
          readonly
          clickable
          @click="showPicker = true"
          placeholder="请选择有效专业"
          is-link
          :value="detail.majorName"
          label="所学专业">
        </van-field> -->

        <van-field
          input-align="right"
          readonly
          clickable
          required
          @click="schoolTime = true"
          placeholder="请选择真实在校时间"
          is-link
          :value="schoolTimes"
          label="在校时间"
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>

        <van-field
          input-align="right"
          readonly
          clickable
          required
          @click="showSelect('overseasEdu')"
          is-link
          :value="detail.overseasEdu"
          label="是否有海外学习经历"
          placeholder="请选择"
          :rules="[{ required: true, message: '' }]"
        >
        </van-field>
      </van-cell-group>

      <div class="fixed-bottom">
        <van-button
          v-if="id && eduLength > 1"
          type="primary"
          class="btn-org-border"
          color="#FFF9F9"
          round
          @click="del($route.query.id)"
          >删 除</van-button
        >
        <van-button
          type="primary"
          class="btn-blue"
          color="linear-gradient(to right top, #2F72F6,#1C54CF)"
          round
          native-type="submit"
          >保 存</van-button
        >
      </div>
    </van-form>

    <!--选择时间-->
    <van-popup v-model="showPicker" position="bottom" style="width: 100%;">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <!--选择生日-->
    <van-popup
      v-model="schoolTime"
      round
      position="bottom"
      style="width: 100%;"
    >
      <van-tabs
        title-active-color="#2D6FF2"
        v-model="active"
        :ellipsis="false"
      >
        <van-tab>
          <template #title>
            <p>入学时间</p>
          </template>
          <van-datetime-picker
            :show-toolbar="false"
            v-model="currentDate.studyStartTime"
            type="date"
            visible-item-count="3"
            item-height="50"
            :formatter="formatter"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </van-tab>
        <van-tab>
          <template #title>
            <p>离校时间</p>
          </template>
          <van-datetime-picker
            :show-toolbar="false"
            v-model="currentDate.studyEndTime"
            type="date"
            visible-item-count="3"
            item-height="50"
            :formatter="formatter"
            :min-date="endMinDate"
            :max-date="endMaxDate"
            @change="endDateChange"
          />
        </van-tab>
      </van-tabs>
      <button class="btn-default" @click="getTime">确定</button>
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "education",
  data() {
    return {
      id: this.$route.query.id,
      eduLength: this.$route.query.eduLength,
      detail: {},
      currentDate: {
        studyStartTime: moment().subtract(3, 'year')._d,
        studyEndTime: moment()._d
      },
      formatDate: "YYYY-MM-DD",
      active: 0,
      minDate: new Date(1990, 0, 1),
      maxDate: moment()._d,
      endMinDate: moment().subtract(3, 'year')._d,
      endMaxDate: moment()._d,
      type: "edu",
      schoolTime: false,
      schoolTimes: "",
      showPicker: false,
      isMajor: ["初中及以下", "高中", "无学历要求"],
      isCert: ["本科", "硕士", "博士"]
    };
  },
  computed: {
    columns() {
      const obj = {
        edu: Array.from(this.module.eduType.keys()),
        certificate: Array.from(this.module.isType.keys()),
        overseasEdu: Array.from(this.module.isType.keys())
      };
      return obj[this.type];
    }
  },
  methods: {
    moment,
    onload(id) {
      this.module.api.eduExpDetail({
        params: { id },
        success: res => {
          for (let [key, value] of this.module.eduType.entries()) {
            value === res.edu && (res.edu = key);
          }
          for (let [key, value] of this.module.isType.entries()) {
            value === res.certificate && (res.certificate = key);
            value === res.overseasEdu && (res.overseasEdu = key);
          }
          this.schoolTimes =
            moment(res.studyStartTime).format("YYYY-MM-DD") +
            " - " +
            moment(res.studyEndTime).format("YYYY-MM-DD");
          this.detail = res;
          this.currentDate = {
            studyStartTime: new Date(res.studyStartTime),
            studyEndTime: new Date(res.studyEndTime)
          };
        }
      });
    },
    showSelect(key) {
      this.type = key;
      this.showPicker = true;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onConfirm(value) {
      this.detail[this.type] = value;
      this.showPicker = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    endDateChange(val) {
      this.endMinDate = moment(this.currentDate.studyStartTime)._d
      this.maxDate = moment(this.currentDate.studyEndTime).subtract(1, 'days')._d
    },
    getTime() {
      let studyStartTime = moment(this.currentDate.studyStartTime).format(
        this.formatDate
      );
      let studyEndTime = moment(this.currentDate.studyEndTime).format(
        this.formatDate
      );
      Object.assign(this.detail, { studyStartTime, studyEndTime });
      this.schoolTimes = studyStartTime + " - " + studyEndTime;
      this.schoolTime = false;
    },
    submit() {
      const {
        edu,
        certificate,
        overseasEdu,
        studyStartTime,
        studyEndTime
      } = this.detail;
      const detail = Object.assign({}, this.detail, {
        edu: this.module.eduType.get(edu),
        certificate: this.module.isType.get(certificate),
        overseasEdu: this.module.isType.get(overseasEdu),
        studyStartTime: moment(studyStartTime).format("YYYY-MM-DD HH:mm:ss"),
        studyEndTime: moment(studyEndTime).format("YYYY-MM-DD HH:mm:ss")
      });
      this.module.api.eduExpSubmit({
        params: detail,
        success: res => {
          this.toast("保存成功");
          this.onClickLeft();
        }
      });
    },
    del(id) {
      this.module.api.eduExpDelete({
        params: { id },
        success: res => {
          this.toast("删除成功");
          this.onClickLeft();
        }
      });
    }
  },
  mounted() {
    this.$route.query.id && this.onload(this.$route.query.id);
  }
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  padding: 20px 16px;
}
/deep/.van-hairline--top-bottom::after,
/deep/.van-hairline-unset--top-bottom::after {
  display: none;
}
/deep/.van-cell__right-icon {
  transform: rotate(90deg);
  top: -4px;
}
.fixed-bottom {
  padding: 10px 16px 20px;
  button {
    flex: 2;
  }
  .btn-org-border {
    border: 1px solid #ff5945 !important;
    box-shadow: none;
    margin-right: 16px;
    flex: 1;
    color: #ff5945;
    .van-button__text {
      color: #ff5945;
    }
  }
}
/deep/.form-cont .van-field__label {
  white-space: nowrap;
}
/deep/.van-tabs--line .van-tabs__wrap {
  height: 72px;
  border-bottom: 1px solid #eee;
}
/deep/.van-tab__text {
  text-align: center;
  padding: 10px;
  display: block;
  p {
    font-size: 12px;
    transform: rotate(0.9);
    color: #5c5d5f;
  }
  span {
    font-size: 16px;
    color: #5c5d5f;
    opacity: 0.5;
  }
}
/deep/.van-tab.van-tab--active {
  span {
    color: #2d6ff2;
    opacity: 1;
  }
}
/deep/.van-tabs__line {
  background: #2d6ff2;
  width: 50%;
  margin-bottom: -1px;
  z-index: 999;
}
/deep/.van-picker-column__item {
  .van-ellipsis {
    font-size: 18px;
  }
}
.btn-default {
  color: #2a2b2c;
  width: 100%;
  font-size: 16px;
  display: block;
  border: none;
  text-align: center;
  border-top: 1px solid #eee;
  padding: 16px 0;
  background: none;
}
/deep/.van-popup {
  min-height: auto;
  border-radius: 0;
  .van-tabs__nav {
    border-radius: 16px 16px 0 0;
  }
}
</style>
